<div class="hcd-dialog">
  <div class="hcd-header">
    <h2 class="hcd-title">Hygiene Activity Details</h2>
    <button type="button" class="hcd-close" (click)="close()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="hcd-body">
    <!-- Left: image + campus + building -->
    <div class="hcd-image-col">
      <div class="hcd-image-wrap">
        <img *ngIf="imageSrc" [src]="imageSrc" [alt]="displayLabel" class="hcd-img">
        <div *ngIf="!imageSrc" class="hcd-img-placeholder">
          <i class="fa fa-image"></i>
        </div>
      </div>
      <div class="hcd-left-details" *ngIf="campusName || buildingName">
        <span *ngIf="campusName" class="hcd-location-item"><strong>Campus:</strong> {{ campusName }}</span>
        <span *ngIf="buildingName" class="hcd-location-item"><strong>Building:</strong> {{ buildingName }}</span>
      </div>
    </div>
    <!-- Right: activity details -->
    <div class="hcd-staff-section">
      <h3 class="hcd-staff-heading">{{ isActivityItem ? 'Activity' : 'Staff Details' }}</h3>
      <div class="hcd-caption" *ngIf="!isActivityItem">
        <span class="hcd-dept">{{ displayLabel }}</span>
        <span class="hcd-meta">{{ formatHygieneTime(picture.hygieneDate) }} · {{ picture.employeeCount }} staff</span>
      </div>
      <div class="hcd-right-details" *ngIf="isActivityItem">
        <span *ngIf="picture?.activityName" class="hcd-detail-line"><strong>Activity:</strong> {{ picture.activityName }}</span>
        <span *ngIf="picture?.floorName" class="hcd-detail-line"><strong>Floor:</strong> {{ picture.floorName }}</span>
        <span *ngIf="picture?.roomDisplayName || (picture?.roomNo != null)" class="hcd-detail-line"><strong>Room:</strong> {{ picture.roomDisplayName ?? picture.roomNo }}</span>
        <span *ngIf="displayDate" class="hcd-detail-line"><strong>Date:</strong> {{ displayDate }}</span>
        <span *ngIf="displayTime" class="hcd-detail-line"><strong>Time:</strong> {{ displayTime }}</span>
        <span *ngIf="picture?.employeeName" class="hcd-detail-line"><strong>Image taken by:</strong> {{ picture.employeeName }}</span>
        <span *ngIf="picture?.designation" class="hcd-detail-line"><strong>Designation:</strong> {{ picture.designation }}</span>
        <span *ngIf="picture?.mobileNo" class="hcd-detail-line"><strong>Mobile No:</strong> {{ picture.mobileNo }}</span>
        <span *ngIf="hasGeolocation" class="hcd-detail-line">
          <strong>Geolocation:</strong>
          <a class="hcd-map-link" (click)="openMap()" href="javascript:void(0)" role="button">View on map</a>
        </span>
      </div>
      <div class="hcd-staff-scroll" *ngIf="!isActivityItem">
        <ul *ngIf="staffList.length" class="hcd-staff-list">
          <li *ngFor="let s of staffList" class="hcd-staff-item">
            <span class="hcd-staff-name">{{ s.staffName ?? '—' }}</span>
            <span class="hcd-staff-aadhar">Aadhar: {{ s.aadharNo ?? '—' }}</span>
          </li>
        </ul>
        <p *ngIf="staffList.length === 0" class="hcd-empty">No staff details in this record.</p>
      </div>
    </div>
  </div>
</div>
